import {
  faChevronRight,
  faRightLeft,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Table } from "react-bootstrap";
import "./To_do_task_managment.css";
import { useNavigate } from "react-router-dom";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";

function To_do_task_managment() {
  const navigate = useNavigate();
  const applications = [
    { name: "Garde Manger", date: "12 Oct 2025" },
    { name: "Sous Chef", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", date: "01 Nov 2025" },
    { name: "Student Advisor", date: "06 Nov 2025" },

    { name: "Garde Manger", date: "12 Oct 2025" },
    { name: "Sous Chef", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", date: "01 Nov 2025" },
    { name: "Student Advisor", date: "06 Nov 2025" },

    { name: "Garde Manger", date: "12 Oct 2025" },
    { name: "Sous Chef", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", date: "01 Nov 2025" },
    { name: "Student Advisor", date: "06 Nov 2025" },
  ];
  return (
    <>
      <section className="To_do_task_managment">
        <div className="heading_text_holder">
          <h4>
            You have <span>4 tasks pending</span>. Complete them to keep your
            application on track.
          </h4>
        </div>
        <div className="progressbar_holder">
          <h2>60% Complete</h2>
          <progress className="pregressbar_strick" value={0.7} />
        </div>
        <div className="card_box">
          <div className="heading_btn_holder">
            <h5 className="mb-3 card_heading_holder">To-Do Task</h5>
          </div>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Task Name</th>
                  <th>Upload Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {applications.map((app, index) => (
                  <tr key={index}>
                    <td>{app.name}</td>
                    <td>{app.date}</td>

                    <td>
                      <div className="action_btn_holder">
                        <Blue_border_button
                          button_text={
                            <>
                              Complete Now{" "}
                              <FontAwesomeIcon
                                icon={faChevronRight}
                                className="ms-3"
                              />
                            </>
                          }
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </section>
    </>
  );
}

export default To_do_task_managment;
